export const PT: Record<string, string> = {
  "Home": "Página Inicial",
  "Resource Selected": "Recurso Selecionado",
  "Resources List": "Lista de Recursos",
  "List": "Lista",
  "Resources": "Recursos",
  "Find Colleague": "Encontrar Colega",
  "Settings": "Configurações",
  "Floor Plan": "Planta do Piso",
  "Locations": "Locais",
  "Categories": "Categorias",
  "Search resource name...": "Pesquisar nome do recurso...",
  "Calendar": "Calendário",
  "View Details": "Ver Detalhes",
  "Add to My Favorites": "Adicionar aos Meus Favoritos",
  "Remove": "Remover",
  "Resource calendar": "Calendário de Recursos",
  "Today": "Hoje",
  "Previous month": "Mês Anterior",
  "Next month": "Próximo Mês",
  "Previous year": "Ano Anterior",
  "Next year": "Próximo Ano",
  "Close": "Fechar",
  "Field is required.": "Campo é obrigatório.",
  "Invalid date format.": "Formato de data inválido.",
  "S": "Dom",
  "M": "Seg",
  "T": "Ter",
  "W": "Qua",
  "F": "Sex",
  "January": "Janeiro",
  "February": "Fevereiro",
  "March": "Março",
  "April": "Abril",
  "May": "Maio",
  "June": "Junho",
  "July": "Julho",
  "August": "Agosto",
  "September": "Setembro",
  "October": "Outubro",
  "November": "Novembro",
  "December": "Dezembro",
  "Jan": "Jan",
  "Feb": "Fev",
  "Mar": "Mar",
  "Apr": "Abr",
  "Jun": "Jun",
  "Jul": "Jul",
  "Aug": "Ago",
  "Sep": "Set",
  "Oct": "Out",
  "Nov": "Nov",
  "Dec": "Dez",
  "st": "º",
  "nd": "º",
  "rd": "º",
  "th": "º",
  "Sunday": "Domingo",
  "Monday": "Segunda-feira",
  "Tuesday": "Terça-feira",
  "Wednesday": "Quarta-feira",
  "Thursday": "Quinta-feira",
  "Friday": "Sexta-feira",
  "Saturday": "Sábado",
  "Sun": "Dom",
  "Mon": "Seg",
  "Tue": "Ter",
  "Wed": "Qua",
  "Thu": "Qui",
  "Fri": "Sex",
  "Sat": "Sáb",
  "Su": "Dom",
  "Mo": "Seg",
  "Tu": "Ter",
  "We": "Qua",
  "Th": "Qui",
  "Fr": "Sex",
  "Sa": "Sáb",
  "PM": "PM",
  "AM": "AM",
  "You cannot book this resource because your meeting request conflicts with the resource's booking policies.":
    "Você não pode reservar este recurso porque sua solicitação de reunião entra em conflito com as políticas de reserva do recurso.",
  "You need permissions to interact with this resource.":
    "Você precisa de permissões para interagir com este recurso.",
  "Reason": "Motivo",
  "The resource cannot be booked {{day}} days in advanced.":
    "O recurso não pode ser reservado {{day}} dias antecipadamente.",
  "The end date of a recurring meeting cannot be more than {{day}} days from today.":
    "A data de término de uma reunião recorrente não pode ser superior a {{day}} dias a partir de hoje.",
  "Meeting duration cannot be longer than {{time}} minutes long.":
    "A duração da reunião não pode ser superior a {{time}} minutos.",
  "Meeting duration cannot be shorter than {{time}} minutes long.":
    "A duração da reunião não pode ser inferior a {{time}} minutos.",
  "Booking policy": "Política de Reserva",
  "Available": "Disponível",
  "Selected": "Selecionado",
  "Booked": "Reservado",
  "Closed": "Fechado",
  "Filter Options": "Opções de Filtro",
  "{{resource}} is deleted": "{{resource}} foi deletado.",
  "This resource can be booked but any occurrences with conflicts the resource will not be booked.":
    "Este recurso pode ser reservado, mas qualquer ocorrência com conflitos não será reservada.",
  "This resource can be booked in advance for a maximum of {{day}} days, any occurrences beyond that limit will not be booked":
    "Este recurso pode ser reservado antecipadamente por um máximo de {{day}} dias, quaisquer ocorrências além desse limite não serão reservadas.",
  "This resource can be booked, but the meeting duration must be at least {{time}} minutes.":
    "Este recurso pode ser reservado, mas a duração da reunião deve ser de pelo menos {{time}} minutos.",
  "This resource can be booked, but the meeting duration must not exceed {{time}} minutes.":
    "Este recurso pode ser reservado, mas a duração da reunião não deve exceder {{time}} minutos.",
  "Booking this resource requires approval by the resource's delegate. Your request will be forwarded, pending approval.":
    "A reserva deste recurso requer aprovação do delegado do recurso. Sua solicitação será encaminhada, aguardando aprovação.",
  "Resource Name": "Nome do Recurso",
  "Description": "Descrição",
  "Resource Mail": "E-mail do Recurso",
  "Location": "Localização",
  "Capacity": "Capacidade",
  "Language": "Idioma",
  "Select an language": "Selecione um idioma",
  "Date/Time Format": "Formato de Data/Hora",
  "First day of the week": "Primeiro dia da semana",
  "Please select a first day": "Por favor, selecione um primeiro dia",
  "Please select a time format": "Por favor, selecione um formato de hora",
  "Date Format": "Formato de Data",
  "Please select a date format": "Por favor, selecione um formato de data",
  "Date Separator": "Separador de Data",
  "Please select a date separator": "Por favor, selecione um separador de data",
  "Apply": "Aplicar",
  "Default Location": "Localização Padrão",
  "Clear": "Limpar",
  "Help": "Ajuda",
  "Unavailable": "Não disponível",
      "No data available": "Sem dados disponíveis",
      "More": "Mais",
  "Available Floor Plans": "Plantas do Piso Disponíveis",
  "Default Categories": "Categorias Padrão",
  "List more Resources": "Listar mais Recursos",
  "Attendees": "Participantes",
  "Click on Further information to visit our support site": "Clique em Mais informações para visitar nosso site de suporte",
  "New Order": "Nova Ordem",
  "Save default categories successfully": "Salvar categorias padrão com sucesso",
      "Save config date/time successfully": "Salvar configuração de data/hora com sucesso",
      "Save language successfully": "Salvar idioma com sucesso",
      "Save default location successfully": "Salvar localização padrão com sucesso",
      "And": "E",
  "Or": "Ou",
  "Available occurrences of the series": "Ocorrências disponíveis da série",
  "Conflicting Occurrences": "Ocorrências conflitantes",
  "Availability": "Disponibilidade",
  "Time Format": "Formato de hora",
  "You do not have permission to book this resource.": "Você não tem permissão para reservar este recurso.",
"This resource does not allow booking of recurring meetings.": "Este recurso não permite a reserva de reuniões recorrentes.",
"You cannot book this resource.": "Você não pode reservar este recurso."
};
